var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBestSubject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 0.320557,
    y: 0.843384,
    width: 46.8138,
    height: 46.8138,
    rx: 23.4069,
    fill: "#2AAC7E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8384 28.3282C29.5215 28.6445 28.1466 28.6291 26.8371 28.2836C25.5275 27.9382 24.324 27.2733 23.3345 26.3485C22.3449 25.4238 21.6001 24.2681 21.1669 22.9849C20.7336 21.7017 20.6253 20.3311 20.8517 18.9957C20.8172 19.029 20.7809 19.0602 20.7428 19.0892C20.473 19.2944 20.1358 19.3705 19.4613 19.5228L18.8495 19.6615C16.4793 20.1982 15.2942 20.466 15.0119 21.3727C14.7305 22.2784 15.5379 23.2236 17.1537 25.113L17.5719 25.6015C18.0305 26.1382 18.2608 26.407 18.3639 26.7384C18.467 27.0709 18.4323 27.4293 18.3629 28.1452L18.2994 28.7975C18.0556 31.319 17.9332 32.5792 18.6713 33.139C19.4093 33.6998 20.5193 33.1891 22.7373 32.1668L23.3125 31.9028C23.9426 31.6119 24.2577 31.4673 24.592 31.4673C24.9263 31.4673 25.2414 31.6119 25.8725 31.9028L26.4458 32.1668C28.6647 33.1881 29.7747 33.6988 30.5118 33.14C31.2508 32.5792 31.1284 31.319 30.8846 28.7975L30.8384 28.3282Z",
    fill: "#2AAC7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M21.849 17.3868L21.5329 17.9533C21.1861 18.5757 21.0126 18.8869 20.7429 19.0922C20.7814 19.0633 20.8171 19.0324 20.8517 18.9987C20.6253 20.3341 20.7336 21.7049 21.1669 22.9882C21.6002 24.2715 22.3451 25.4273 23.3348 26.352C24.3245 27.2768 25.5281 27.9416 26.8378 28.2871C28.1475 28.6325 29.5224 28.6476 30.8394 28.3312L30.8202 28.1482C30.7517 27.4323 30.7171 27.0738 30.8202 26.7414C30.9233 26.41 31.1526 26.1412 31.6122 25.6045L32.0303 25.116C33.6461 23.2275 34.4535 22.2823 34.1712 21.3757C33.8899 20.469 32.7048 20.2002 30.3345 19.6645L29.7218 19.5258C29.0483 19.3735 28.711 19.2974 28.4403 19.0922C28.1705 18.8869 27.9971 18.5757 27.6502 17.9533L27.3352 17.3868C26.1144 15.1977 25.5045 14.1031 24.5921 14.1031C23.6796 14.1031 23.0697 15.1977 21.849 17.3868Z",
    fill: "#2AAC7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestSubject);
export default __webpack_public_path__ + "static/media/BestSubject.2c6d67c337664bf240c7973f82cca72c.svg";
export { ForwardRef as ReactComponent };